import { Product } from 'state/product'
import sortBy from 'lodash.sortby'
import { classList } from 'MK/DOM/fns/classList'
import { Color } from 'state/color'

MK.events.on('products:updateDOM', (event = {}) => {
  MK.events.emit('product:calculateActiveProducts', {
    initiator: 'products:updateDOM',
    initialLoad: event.initialLoad
  })
  // Filter active products (by ID or Color) from the product index and sort them by the current active sort order.
  // Sort active products
  let products = sortBy(Product.active, [`sortOrder.${Product.sort.order}`])
  console.log('Products:', products)
  console.log('Colors:', Object.values(Color.by.alias).filter(alias => alias.is.active))
  console.log('SKUs:', Product.index.skus)

  // Reverse the order of products, if required.  (eg: Sort by Rating, Sort by Price High - Low)
  if (Product.sort.reverse) {
    products = products.reverse()
  }

  // Hide product container
  !classList.has(Product.container, 'hide') && classList.add(Product.container, 'hide')

  // Clear existing DOM nodes.
  while (Product.container.firstChild) {
    Product.container.removeChild(Product.container.firstChild)
  }

  // Add products to DOM
  products.forEach(product => {
    Product.container.appendChild(
      product.createDOMNodes()
    )
  })

  // Unhide product container
  classList.has(Product.container, 'hide') && classList.remove(Product.container, 'hide')

  MK.utils.lazyLoad.observe()
})

